import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { addSubscriber } from "../services/newsletterService";
import useBusinessHours from "../hooks/useBusinessHours";

const FooterAreaOne = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState(null);
  const { summary, loading, error } = useBusinessHours();

  // Clean up toast timeout on unmount
  useEffect(() => {
    if (toast) {
      const timeoutId = setTimeout(() => setToast(null), 4000);
      return () => clearTimeout(timeoutId);
    }
  }, [toast]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setToast({
        type: "error",
        message: "Por favor, introduce un email válido."
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const result = await addSubscriber(email);

      setToast({
        type: result.success ? "success" : "error",
        message: result.message
      });

      if (result.success) {
        setEmail("");
      }
    } catch (error) {
      setToast({
        type: "error",
        message: "Error al procesar la suscripción. Inténtalo de nuevo."
      });
    }

    setIsSubmitting(false);
  };

  return (
    <footer
      className="footer-wrapper footer-layout1"
      style={{ backgroundImage: "url(assets/img/bg/footer-bg1-1.png)" }}
    >
      <div className="container">
        <div className="widget-area">
          <div className="row justify-content-between">
            <div className="col-md-6 col-xl-auto">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Servicios</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    <li>
                      <Link to="/chapa-y-pintura/cambio-de-color">Cambio de Color</Link>
                    </li>
                    <li>
                      <Link to="/chapa-y-pintura/reparacion-llantas">Reparación de llantas</Link>
                    </li>
                    <li>
                      <Link to="/chapa-y-pintura/lunas-y-cristales">Lunas y gestión de franquiciados</Link>
                    </li>
                    <li>
                      <Link to="/mantenimiento/pulido-faros">Pulido de faros, Carga A/C, Neumáticos</Link>
                    </li>
                    <li>
                      <Link to="/mecanica">Mecánica, Revisiones gratuitas pre-ITV</Link>
                    </li>
                    <li>
                      <Link to="/mantenimiento/aceite-y-filtros">Filtros y Aceite</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
                <h3 className="widget_title">Contacto</h3>
                <div className="widget-contact">
                    <p>
                      <i className="fas fa-envelope" />
                      <Link className="link" to="mailto:taller@lealchapaypintura.com"><span>  taller@lealchapaypintura.com</span></Link>
                    </p>
                    <p>
                      <i className="fas fa-map-marker-alt" />
                      <Link to="https://www.google.com/maps/place//data=!4m2!3m1!1s0xd126d27da03445b:0x4605fa9dd282f634?sa=X&amp;ved=1t:8290&amp;ictx=111"><span> C. Congreso, 57 | Polígono P.I.S.A | Mairena del Aljarafe, Sevilla</span></Link>
                    </p>
                    <p style={{ margin: 0, lineHeight: 1.3 }}>
                      <i className="fas fa-clock" />
                      <span> {summary || 'Horario no disponible'}</span>
                    </p>
                    {loading && (
                      <p style={{ margin: 0, lineHeight: 1.3 }}>
                        <span> Cargando horario...</span>
                      </p>
                    )}
                    {!loading && error && (
                      <p style={{ margin: 0, lineHeight: 1.3 }}>
                        <span> Horario: no disponible</span>
                      </p>
                    )}
                    {/* summary is displayed on the main clock line above */}
                  <p>
                    <br />
                    Profesionales de chapa y pintura automovilística desde 1995 <br />
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget widget-newsletter">
                <h3 className="widget_title">Promociones y Ofertas </h3>
                <p className="footer-text mb-50">
                  Subscríbete para recibír nuestras exclusivas ofertas
                </p>
                <form className="newsletter-form" onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      className="form-control"
                      type="email"
                      placeholder="Correo Electrónico"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={isSubmitting}
                      required
                    />
                  </div>
                  <button type="submit" className="btn" disabled={isSubmitting}>
                    {isSubmitting ? (
                      <i className="fas fa-spinner fa-spin" />
                    ) : (
                      <i className="fas fa-arrow-right" />
                    )}
                  </button>
                </form>
                {/* Toast notification */}
                {toast && (
                  <div className={`newsletter-toast ${toast.type === "error" ? "error" : ""}`}>
                    <i className={`fas ${toast.type === "success" ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                    <span>{toast.message}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-wrap">
        <div className="container">
          <div className="row gy-3 justify-content-md-between justify-content-center">
            <div className="col-auto align-self-center">
              <p className="copyright-text text-center">
              Coypyright © {new Date().getFullYear()} Leal Chapa y Pintura SL. Todos los derechos reservados.
              </p>
            </div>
            <div className="col-auto">
              <div className="footer-links">
                <Link to="/terminos">Términos &amp; Condiciones</Link>
                <Link to="/privacidad">Políticas de privacidad</Link>
                <Link to="https://www.sdsdeliver.io">Made with ❤️ by SDS Deliver IO</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterAreaOne;
